import { FC } from "react"
import { TravelersSearch } from "../../../module/travelers/containers/search"

export const TravelersSearchPage: FC = () => <TravelersSearch />
